'use strict'
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css'; 

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeEvent = this.onChangeEvent.bind(this);
    }

    componentWillMount(){
        // jQuery('.selectpicker').selectpicker('refresh');
        

    }

    componentDidUpdate(prevProps){
        if (prevProps.label_array !== this.props.label_array) {
            let obj = null;
            let form = Object.values(this.props.label_array);
            form.map((element, i) => {
                // if(element?.searchEnabled == true){
                //     obj = { searchEnabled: true };
                // }
                this.initializeChoices(element); // Reinitialize Choices.js with the updated options
            })
        }

    }

    onChangeEvent(e){
        if (this.props.handleForm !== undefined && this.props.handleForm !== null ){
            this.props.handleForm(e);
        }
    }

    componentDidMount(){
        let addConnectionPage = window.location.pathname == "/adminpanel/v2/initialize_connector"
        let obj = null;

        let form = Object.values(this.props.label_array);
        form.map((element, i) => {
            // if(element?.searchEnabled == true){
            //     obj = { searchEnabled: true };
            // }
            this.initializeChoices(element);
        })
        if(this.props.label_array.dashboardEndTime){
            let min = this.props.label_array.dashboardEndTime.min;
            let max = this.props.label_array.dashboardEndTime.max;
            jQuery('.date_field').datepicker({
                showOtherMonths: true,
                selectOtherMonths: true,
                changeMonth: true,
                changeYear: true,
                language: "en",
                minDate: new Date(min),
                maxDate: new Date(max)
            });
        }
    }
    initializeChoices(dropdownData) {
        const dropdown = document.querySelectorAll(`.js-choice[name="${dropdownData.name}"]`);
        dropdown.forEach((selectElement) => {
            // Destroy existing Choices instance if it exists
            if (selectElement.choicesInstance) {
                try {
                    selectElement.choicesInstance.destroy();
                } catch (error) {
                    console.error("Error destroying Choices.js instance.");
                }
            }

            // Initialize Choices.js
            const choicesInstance = new Choices(selectElement, {
                searchEnabled: dropdownData?.searchEnabled == true ? true : false,
                removeItemButton: true,
                shouldSort: false,
                classNames: {
                    containerInner: 'custom-class-for-container',
                    listDropdown: 'custom-class-for-dropdown'
                }
            });

            // Attach the instance to the DOM element for cleanup later
            selectElement.choicesInstance = choicesInstance;
        });
       
    }
    setCustomTextField(index, name, text_value, type, form = null, min = null, max = null, disabledFlag = null) {
        let field_name = form === null ? `name_${index}` : name;

        let field = (<input type={type} className="form-control" defaultValue={text_value} id={`${name}_${index}`} name={field_name} disabled={disabledFlag} onChange={this.onChangeEvent}  />)

        if (this.props.flag !== undefined && this.props.flag !== null ){
            if (this.props.flag == "value"){
                field = (<input type={type} className="form-control" value={text_value} id={`${name}_${index}`} name={field_name} onChange={this.onChangeEvent} disabled={disabledFlag} />)
            }
        }

        if (type == "number") {
            field = (<input type={type} min="0" className="form-control" defaultValue={text_value} id={`${name}_${index}`} name={field_name} onChange={this.onChangeEvent} disabled={disabledFlag} key={`${field_name}_${text_value}`} />)
        }
        if (type == "custom") {
            field = (
                <div className="input-group">
                    <input id={`${name}_${index}`} type={type} className="form-control" aria-label="CustomFormula" aria-describedby="button-addon2" /><div className="input-group-append">
                        <button className="btn btn-sm btn-primary" type="button" id="button-addon2">Validate</button></div>
                </div>);
        }
        if (type == "date") {
            field = (<div className="input-group w-100">
                <input
                    type="text"
                    className="form-control date_field bd-r-1"
                    defaultValue={text_value}
                    id={`${name}_${index}`}
                    name={field_name}
                    onChange={this.onChangeEvent}
                    data-date-format="yyyy-mm-dd"
                />
                <span className="input-group-text bg-white">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-calendar"
                        viewBox="0 0 16 16"
                    >
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v1H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM0 14V5h16v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" />
                    </svg>
                </span>
            </div>)
        }
        if (type == "datetime-local") {
            field = (<input type={type} className="form-control" defaultValue={text_value} id={`${name}_${index}`} step="1" name={field_name } onChange={this.onChangeEvent}  />
     )
        }
        return field;
    }
  
    
    largeTextField(index, name, text_value, type, form = null) {
        let field_name = form === null ? `name_${index}` : name;

        let field = (<textarea className="form-control" defaultValue={text_value} id={`textarea_${index}`} name={field_name} />)

        return field;
    }

    setDropdown(index, name, option_list, defaultValue, handleChange, form = null, multiple = false) {
        let options = [];
        option_list.map((element, i) => {
            let innerElement = null;
            innerElement = <option value={element.value} key={`${element.value}_${index}_${i}`}>{element.name}</option>;
            options.push(innerElement);
        });
        let dropdown_name = form === null ? `custom_${index}` : name;
    
        return ( 
            <select 
                className="js-choice  form-control form-select" 
                id={`${name}_${index}`} 
                defaultValue={defaultValue} 
                name={dropdown_name} 
                onChange={handleChange} 
                multiple={multiple}
                >
                {options}
                
            </select>
        );
    }

    setFileInput(){

    }

    render() {
        let form = [];

        let headers = Object.values(this.props.label_array);
        let that = this;

        headers.map((element, i) => {
            var change_handle = that.props.handle_form_drop_down ? that.props.handle_form_drop_down : null;
            let text_value = (element.text_value !== undefined && element.text_value !== null) ? (element.text_value) : "";
            let disabledFlag = (element.disabled !== null && element.disabled !== undefined)?element.disabled:null;

            if ( ["text","date","email","password","number","time",'datetime-local'].includes(element.type)) {
                let min = element.type == "date" ||  element.type == "datetime-local"?element.min:null;
                let max = element.type == "date" ||  element.type == "datetime-local"?element.max:null;
                form.push(
                    <div key={`form_input_${i}`} className="form-group" id={`form_input_${element.name}`}>
                        <label htmlFor={`form_data`}>{`${element.label}`}</label>
                        {that.setCustomTextField(`form_data`, element.name, text_value, element.type, 1,min,max,disabledFlag)}
                    </div>
                );
            }

            if (element.type == "text-large") {
                form.push(
                    <div key={`form_input_${i}`} className="form-group" id={`form_input_${element.name}`}>
                        <label htmlFor={`form_data`}>{`${element.label}`}</label>
                        {that.largeTextField(`form_data`, element.name, text_value, element.type, 1)}
                    </div>
                );
            }
            if (element.type == "dropdown") {
                // form.push(
                //     <div key={`form_input_${i}`} className="form-group" id={`form_input_${element.name}`}>
                //         <label className="mg-r-10" htmlFor={`form_data`}>{`${element.label}`}</label>
                //         {that.setDropdown(`form_data`, element.name, element.options, text_value, change_handle, 1, element.multiple)}
                //     </div>
                // );
                form.push(
                    <div key={`row_${i}`} className="row mb-2">
                        <div key={`col_${i}`} className="">
                                {element.label && <label className="mg-r-10" htmlFor={`form_data`}>{`${element.label || ""}`}</label>}
                                {that.setDropdown(`form_data`, element.name, element.options, text_value, change_handle, 1, element.multiple)}
                        </div>
                    </div>
                );
            }

            if (element.type == "file") {
                let id = (element.id !== null && element.id !== undefined)?element.id:"customFile";
                form.push(
                    <div key={`form_input_${i}`} className="form-group">
                        <label className="mg-r-10" htmlFor={`form_data`}>{`${element.label}`}</label>
                        <div className="custom-file" id={`form_input_${element.name}`}>                        
                            
                            {element.name == "zipFileName" ? 
                                <input type="file" accept=".zip" className="custom-file-input" id={id} />:
                                <input type="file" accept=".csv" className="custom-file-input" id={id} />}

                            <label className="custom-file-label" htmlFor={id}>Choose File</label>
                            {element.name == "zipFileName" ? null : <div className="mg-x-5 mg-y-5">
                                <span className=" tx-medium">Note:</span>
                                <br/>
                                <span className=" tx-medium">1.Supported file format is CSV.</span>
                                <br />
                                <span className=" tx-medium">2.Upload file of size below 100MB only.</span>
                            </div>}
                        </div>
                    </div>
                );
            }

            if (element.type == "checkbox") {
                form.push(
                    <div key={`form_input_${i}`} className="custom-file" id={`form_input_${element.name}`}>
                        <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" id={`form_input_${element.name}`}/>
                            <label className="custom-control-label" htmlFor={`form_input_${element.name}`}>${element.label}</label>
                        </div>
                    </div>
                );
            }


        });
        return form;
    }
}

export default Form;